import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { MKT_CLIENTS_COUNT } from "common/variables";
import Image from "common/components/image";

const BRAND_ICONS = [
  {
    url: "https://assets.crowdspring.com/marketing/microsoft-logo-bw.png",
    alt: "Microsoft logo",
  },
  {
    url: "https://assets.crowdspring.com/marketing/starbucks-logo-bw.png",
    alt: "Starbucks logo",
  },
  {
    url: "https://assets.crowdspring.com/marketing/amazon-logo-bw.png",
    alt: "Amazon logo",
  },
  {
    url: "https://assets.crowdspring.com/marketing/lg-logo-bw.png",
    alt: "LG logo",
  },
  {
    url: "https://assets.crowdspring.com/marketing/barilla-logo-bw.png",
    alt: "Barilla logo",
  },
  {
    url: "https://assets.crowdspring.com/marketing/p&g-logo-bw.png",
    alt: "P&G logo",
  },
  {
    url: "https://assets.crowdspring.com/marketing/aliexpress-logo-bw.png",
    alt: "AliExpress logo",
  },
];

const TrustedBy2 = ({ background }) => {
  return (
    <section className={cn("block block-trusted-by-2", background)}>
      <div className="row columns small-16">
        <p>
          Over {MKT_CLIENTS_COUNT} startups, small businesses, and leading
          brands trust crowdspring for high-quality designs without the high
          costs.
        </p>
      </div>
      <div className="row align-center align-middle small-up-3 medium-up-5 large-up-7">
        {BRAND_ICONS.map((b, i) => (
          <div className="column" key={i}>
            <Image src={b.url} alt={b.alt} />
          </div>
        ))}
      </div>
    </section>
  );
};

TrustedBy2.propTypes = {
  background: PropTypes.string,
};

export default TrustedBy2;
